/*
  Consulting page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import telegram from '../assets/images/telegram-200px.png'
import fullstackLogo from '../assets/images/fullstackcash-Grey.png'

function Consulting () {
  return (
    <>
      <Helmet>
        <title>Consulting - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col>
            <h2 className='text-center mb-4'>Get the Help Your Business Needs</h2>
            <p className='text-center'>
              FullStack.cash is part of
              the <a href='https://psfoundation.cash' target='_blank' rel='noreferrer'>Permissionless Software Foundation</a>, a network of independent developers
              around the globe, focusing on Bitcoin Cash. We can help connect
              you with the developer resources your company needs.
            </p>
          </Col>
        </Row>

        <Row className='mb-4'>
          <Col md={6} className='mb-4 mb-md-0'>
            <Card className='h-100'>
              <Card.Body>
                <Link to='/contact' className='text-decoration-none'>
                  <img src={fullstackLogo} alt='FullStack.cash' className='img-fluid mb-3' />
                  <h3>FullStack.cash Consulting Services</h3>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className='h-100'>
              <Card.Body>
                <p>
                  FullStack.cash can provide the developer talent to help you
                  achieve your business goals. We specialize in
                  developing <a href='https://cashstack.info' target='_blank' rel='noreferrer'>infrastructure</a> and
                  the <a href='https://psfoundation.info' target='_blank' rel='noreferrer'>software maintained by the PSF</a>.
                </p>
                <p>
                  If you have an app idea and would like help from FullStack.cash,
                  we are available for at a rate of $100 per hour for long-term
                  contracts (a month or longer), or $150 per hour for short-term tasks.
                </p>
                <Button as={Link} to='/contact' variant='primary'>
                  Contact Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md={6} className='mb-4 mb-md-0'>
            <Card className='h-100'>
              <Card.Body>
                <a href='https://t.me/slp_devs_for_hire' target='_blank' rel='noreferrer' className='text-decoration-none'>
                  <img src={telegram} alt='Telegram' className='img-fluid mb-3' />
                  <h3>SLP Token Devs for Hire</h3>
                </a>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className='h-100'>
              <Card.Body>
                <p>
                  Join our Telegram channel to connect with developers who specialize
                  in building SLP token applications and Bitcoin Cash infrastructure.
                </p>
                <Button
                  href='https://t.me/slp_devs_for_hire'
                  target='_blank'
                  rel='noreferrer'
                  variant='primary'
                >
                  Join Telegram Channel
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Consulting
